export default __webpack_public_path__ + "static/media/Jewelry.96adecaf.pdf";